














import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { CustomIndexingLookupsHelper } from '@/mixins/customIndexingLookupsHelper';
import { AutomotiveEntityType, AutomotiveSchema, SchemaModel } from '@/types';
import { AutomotiveDocumentToStoreService } from '@/services';

export default Vue.extend({
  name: 'ForwardOrderOrFreeRelease',
  mixins: [CustomIndexingLookupsHelper],
  props: {
    storeNamespace: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions({
      setSchemaValuesFromReferences(dispatch, payload) {
        return dispatch(`${this.storeNamespace}/setSchemaValuesFromReferences`, payload);
      }
    }),
    async onButtonClick(this: any, dealType: string) {
      try {
        const schema: SchemaModel[] = this.referenceFields;

        const stockNumberField = schema.find(
          (model: SchemaModel) => model.label.toLowerCase() === AutomotiveSchema.Labels.stockNumberLabel.toLowerCase()
        );

        if (stockNumberField) {
          const entityId = await AutomotiveDocumentToStoreService.getNextEntityIdAsync(
            AutomotiveEntityType.ForwardOrderOrFreeReleaseNumber
          );
          const dealership = this.schemaValueByLabel(AutomotiveSchema.Labels.dealershipLabel).toUpperCase();
          const salesExec = this.schemaValueByLabel(AutomotiveSchema.Labels.salesExecLabel).toUpperCase();
          const customer = this.schemaValueByLabel(AutomotiveSchema.Labels.customerLabel);

          const stockNumber = `${dealType}${entityId}-${dealership}-${salesExec}-${customer}`;

          this.setSchemaValuesFromReferences({ [stockNumberField.id]: stockNumber });
        }

        this.closeModal();
      } catch (error) {
        this.$log(error);
        this.$bvModal
          .msgBoxOk('Unable to update Forward Order or Free Release stock number', this.modalOptions())
          .then(() => this.closeModal());
      }
    },
    schemaValueByLabel(this: any, label: string): any {
      const schema = this.referenceFields.find(
        (schema: SchemaModel) => schema.label.toLowerCase() === label.toLowerCase()
      );

      return schema?.value;
    },
    modalOptions() {
      return {
        title: 'Forward Order or Free Release',
        okVariant: 'warning'
      };
    },
    schemaLabels() {
      return [
        AutomotiveSchema.Labels.dealershipLabel,
        AutomotiveSchema.Labels.salesExecLabel,
        AutomotiveSchema.Labels.customerLabel
      ];
    },
    allSchemaLabels(this: any) {
      return [AutomotiveSchema.Labels.stockNumberLabel, ...this.schemaLabels()];
    }
  },
  computed: {
    ...mapState({
      referenceFields(state: any, getters: any) {
        return getters[`${this.storeNamespace}/referenceFields`];
      }
    }),
    missingFieldLabels(this: any) {
      const missingFields: string[] = this.allSchemaLabels().filter(
        (label: string) =>
          !this.referenceFields.some((model: SchemaModel) => model.label.toLowerCase() === label.toLowerCase())
      );

      return missingFields && missingFields.length ? missingFields.join(', ') : '';
    },
    invalidFieldLabels(this: any) {
      const invalidFields: SchemaModel[] = this.referenceFields.filter(
        (model: SchemaModel) =>
          this.schemaLabels().some((label: string) => label.toLowerCase() === model.label.toLowerCase()) &&
          !model.value
      );

      return invalidFields && invalidFields.length ? invalidFields.map((field) => field.label).join(', ') : '';
    }
  },
  mounted(this: any) {
    let message = null;

    if (this.missingFieldLabels) {
      message =
        'Unable to generate a Forward Order or Free Release stock number because ' +
        `the following fields have not been configured for this document type: ${this.missingFieldLabels}`;
    } else if (this.invalidFieldLabels) {
      message =
        'Please enter a value into the following fields to create a ' +
        `Forward Order or Free Release stock number: ${this.invalidFieldLabels}`;
    }

    if (message) {
      this.$bvModal.msgBoxOk(message, this.modalOptions()).then(() => this.closeModal());
    }
  }
});
